import { render, staticRenderFns } from "./SocialGrid2.vue?vue&type=template&id=49b20a65&scoped=true"
import script from "./SocialGrid2.vue?vue&type=script&lang=js"
export * from "./SocialGrid2.vue?vue&type=script&lang=js"
import style0 from "./SocialGrid2.vue?vue&type=style&index=0&id=49b20a65&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49b20a65",
  null
  
)

export default component.exports